import BreadCrumb from "../common/breadcrumb";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import AboutMain from "./about";
import Video from "./video";
import ChairmanMessage from "./chairmanMessage";
import Team from "./team";
import FooterTwo from "../../layout/footers/footer-two";

const AboutUs = () => {
    return (
        <>
            <SEO pageTitle="About Us" />
            <HeaderTwo />
            <BreadCrumb title="About Us" innerTitle="About Us" />
            <AboutMain />
            {/* <Video /> */}
            {/* <Certification /> */}
            <ChairmanMessage />
            {/* <Team /> */}
            <FooterTwo />
        </>
    );
};

export default AboutUs;